import React from 'react';
import { Link } from 'react-router-dom';
import { collection, query, where, orderBy } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { formatShortDate, formatShortDateTime } from '../../utils/dateUtils';
import LoadingSpinner from '../loading-spinner/loading-spinner';
import ErrorDisplay from '../error-display/error-display';
import useFirestoreQuery from '../../hooks/useFirestoreQuery';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Helper function to strip HTML tags for preview
const stripHtmlTags = (html) => {
  if (!html) return '';
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

const BlogsListPublic = () => {
  // Use our custom hook to fetch published blogs
  const { data: blogs, loading, error } = useFirestoreQuery({
    queryFn: () => query(
      collection(db, 'blogs'),
      where('isPublished', '==', true),
      orderBy('createdAt', 'desc')
    ),
    dependencies: [],
    transformFn: (querySnapshot) => {
      const blogsList = [];
      querySnapshot.forEach((doc) => {
        blogsList.push({
          ...doc.data(),
          id: doc.id,
        });
      });
      return blogsList;
    }
  });

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <ErrorDisplay message={error} />;
  }

  if (blogs.length === 0) {
    return (
      <ErrorDisplay
        message="No blog posts available at this time. Check back later!"
        type="info"
      />
    );
  }

  return (
    <div className="row">
      {blogs.map(blog => (
        <div className="col-lg-4 col-md-6 mb-4" key={blog.id}>
          <div className="card h-100">
            {/* Display image if available */}
            {blog.imageUrl && (
              <img
                src={blog.imageUrl}
                className="card-img-top"
                alt={blog.title}
                style={{ height: '200px', objectFit: 'cover' }}
              />
            )}
            
            <div className="card-body">
              <h5 className="card-title">{blog.title}</h5>
              
              {/* Display event date and time if available */}
              {blog.eventDate && (
                <div className="badge bg-info text-white mb-2">
                  <i className="bi bi-calendar-event me-1"></i>
                  {formatShortDateTime(blog.eventDate)}
                </div>
              )}
              
              <p className="card-text">
                {(() => {
                  const plainText = stripHtmlTags(blog.content);
                  return plainText.length > 150
                    ? plainText.substring(0, 150) + '...'
                    : plainText;
                })()}
              </p>
            </div>
            <div className="card-footer">
              <small className="text-muted">
                Posted on {formatShortDate(blog.createdAt)}
              </small>
              <Link to={`/blogs/${blog.id}`} className="btn btn-sm btn-primary float-end">
                Read More
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogsListPublic;